package com.zaurh.mapquizwebsite.presentation.screen.main.left

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.interaction.Interaction
import androidx.compose.foundation.interaction.InteractionSource
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Interval
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.zaurh.mapquizwebsite.utils.getOutfitFont
import kotlinx.browser.window
import mapquizwebsite.shared.generated.resources.Res
import mapquizwebsite.shared.generated.resources.app_store_download
import mapquizwebsite.shared.generated.resources.google_play_download
import mapquizwebsite.shared.generated.resources.ic_daily_rewards
import mapquizwebsite.shared.generated.resources.ic_home
import mapquizwebsite.shared.generated.resources.ic_info
import mapquizwebsite.shared.generated.resources.ic_news
import mapquizwebsite.shared.generated.resources.ic_store
import mapquizwebsite.shared.generated.resources.mapquiz_logo
import mapquizwebsite.shared.generated.resources.play_online
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun MainScreenLeft(
    modifier: Modifier = Modifier,
    onHomeClicked: () -> Unit,
    onDailyRewardClicked: () -> Unit
) {
    Surface(modifier = modifier) {
        Column(
            modifier = Modifier.fillMaxSize().padding(12.dp)
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(start = 12.dp)
                    .pointerHoverIcon(icon = PointerIcon.Hand)
                    .clickable(
                        indication = null,
                        interactionSource = remember { MutableInteractionSource() }
                    ) {
                        onHomeClicked()
                    }, horizontalArrangement = Arrangement.Start
            ) {
                Image(
                    painter = painterResource(Res.drawable.mapquiz_logo),
                    contentDescription = null,
                    modifier = Modifier.size(48.dp)
                )
                Spacer(modifier = Modifier.width(12.dp))
                Column {
                    Text(
                        text = "MapQuiz",
                        fontFamily = getOutfitFont(),
                        fontWeight = FontWeight.Bold
                    )
                    Text(text = "Official Page", fontFamily = getOutfitFont(), fontSize = 12.sp)
                }
            }
            Spacer(modifier = Modifier.height(12.dp))
            MainScreenLeftMenuItem(
                title = "Home",
                selected = true,
                icon = Res.drawable.ic_home,
                onClick = {
                    onHomeClicked()
                }
            )
            MainScreenLeftMenuItem(
                title = "Store",
                selected = true,
                icon = Res.drawable.ic_store,
                onClick = {}
            )
            MainScreenLeftMenuItem(
                title = "Daily rewards",
                selected = true,
                icon = Res.drawable.ic_daily_rewards,
                onClick = {
                    onDailyRewardClicked()
                }
            )
            MainScreenLeftMenuItem(
                title = "News",
                selected = true,
                icon = Res.drawable.ic_news,
                onClick = {}
            )
            MainScreenLeftMenuItem(
                title = "About",
                selected = true,
                icon = Res.drawable.ic_info,
                onClick = {}
            )
            Spacer(modifier = Modifier.height(24.dp))
            DownloadSourceItem(
                image = Res.drawable.play_online,
                onClick = {
                    window.open(
                        "https://mapquiz.zaurway.workers.dev/",
                        "_blank"
                    )
                }
            )
            Spacer(modifier = Modifier.height(12.dp))
            DownloadSourceItem(
                image = Res.drawable.google_play_download,
                onClick = {}
            )
            Spacer(modifier = Modifier.height(12.dp))
            DownloadSourceItem(
                image = Res.drawable.app_store_download,
                onClick = {}
            )
        }
    }
}

@Composable
fun MainScreenLeftMenuItem(
    title: String,
    selected: Boolean,
    icon: DrawableResource,
    onClick: () -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .pointerHoverIcon(icon = PointerIcon.Hand)
            .clip(RoundedCornerShape(10.dp))
            .clickable {
                onClick()
            }
            .padding(vertical = 12.dp, horizontal = 24.dp)

    ) {
        Icon(
            painter = painterResource(icon),
            contentDescription = null,
            modifier = Modifier.size(24.dp),
            tint = MaterialTheme.colorScheme.primary
        )
        Spacer(modifier = Modifier.width(8.dp))
        Text(
            text = title,
            fontFamily = getOutfitFont()
        )
    }
}

@Composable
private fun DownloadSourceItem(
    image: DrawableResource,
    onClick: () -> Unit
){
    Image(
        modifier = Modifier.width(240.dp).pointerHoverIcon(icon = PointerIcon.Hand).padding(horizontal = 12.dp).clickable {
            onClick()
        },
        painter = painterResource(image),
        contentDescription = null
    )
}